import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-diamond-normalcolor",
  "use": "icon-diamond-normalcolor-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-diamond-normalcolor\">\n    <title>Oval</title>\n    <g id=\"icon-diamond-normalcolor_页面-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n      <path d=\"M0 -1L1 0L0 1L-1 0Z\" transform=\"matrix(5,0,0,5,7,7)\" fill=\"#fff\" stroke=\"#87B75B\" stroke-width=\"0.5\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol